import {
  addDoc, collection, deleteDoc, doc, limit, onSnapshot, orderBy, query, Timestamp, updateDoc, where,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { docsWithId, logListenerError } from './db';

const notificationRef = (id) => doc(db, 'notifications', id);

/**
 * Notify another member. senderId must be the signed-in user's profile ID (enforced
 * by security rules). Extra fields (postId, connectionId, ...) are stored as given.
 */
export function notify({ recipientId, senderId, type, message, ...extra }) {
  return addDoc(collection(db, 'notifications'), {
    recipientId, senderId, type, message, ...extra, createdAt: Timestamp.now(), seen: false,
  });
}

/** Live notifications for a profile: the newest `max`, newest first. */
export function subscribeNotifications(profileId, onChange, onError = logListenerError('notifications'), max = 50) {
  const q = query(collection(db, 'notifications'), where('recipientId', '==', profileId), orderBy('createdAt', 'desc'), limit(max));
  return onSnapshot(q, (snapshot) => onChange(docsWithId(snapshot)), onError);
}

export function markNotificationSeen(id) {
  return updateDoc(notificationRef(id), { seen: true });
}

export function updateNotification(id, data) {
  return updateDoc(notificationRef(id), data);
}

export function deleteNotification(id) {
  return deleteDoc(notificationRef(id));
}
